import { ErrorBoundary } from '@ori/logger';
import { useDisclose } from '@ori/presentation-hooks';
import { type FC } from 'react';

import { useTopAreaBanner } from '../../../../context';
import { OrderOnBehalf } from '../../../OrderOnBehalf';
import { Root } from '../../styles';
import { BannersCarousel } from '../BannersCarousel';
import { TopAreaBannerDialog } from '../TopAreaBannerDialog';

export const TopAreaBannerContent: FC = () => {
  const { isOrderOnBehalfVisible, bannersData = [] } = useTopAreaBanner();
  const { open, onClose, onOpen } = useDisclose();

  if (isOrderOnBehalfVisible) {
    return (
      <Root isOrderOnBehalfVisible>
        <OrderOnBehalf />
      </Root>
    );
  }

  return (
    <>
      <BannersCarousel
        items={bannersData}
        onOpen={onOpen}
      />
      <ErrorBoundary areaName="TopAreaBannerContent">
        <TopAreaBannerDialog
          open={open}
          onClose={onClose}
        />
      </ErrorBoundary>
    </>
  );
};
